import { Dispatch, SetStateAction, useEffect, useState } from 'react'

export const useDay = (days: string[]): [string, Dispatch<SetStateAction<string>>] => {
    const [day, setDay] = useState(days[0])

    useEffect(() => {
        setDay(days[0])
    }, [days])

    return [day, setDay]
}
